import { List, Map } from 'immutable';
import createSelector from '../../utils/reselect';

const getAccounting = (state: any) => {
    const { accounting } = state;
    return accounting || Map();
};

export const getInvoiceTypes = createSelector(getAccounting, (state) => {
    return state.getIn(['invoiceTypes', 'data']) ?? List();
});

export const getInvoiceTypesLoading = createSelector(getAccounting, (state) => {
    return state.getIn(['invoiceTypes', 'loading']);
});

export const getFeeTypes = createSelector(getAccounting, (state) => {
    return state.getIn(['feeTypes', 'data']) ?? List();
});

export const getFeeTypesLoading = createSelector(getAccounting, (state) => {
    return state.getIn(['feeTypes', 'loading']);
});

export const getJournalEntries = createSelector(getAccounting, (state) => {
    return state.getIn(['journalEntries', 'data']) ?? List();
});

export const getJournalEntriesLoading = createSelector(getAccounting, (state) => {
    return state.getIn(['journalEntries', 'loading']);
});

export const getAccountingUpdateStatus = createSelector(getAccounting, (state) => {
    return state.getIn(['updateStatus']) ?? '';
});
